<template>
  <div class="wizard-drag-zone" :style="computedStyle">
    <eg-icon
      class="drag-handle"
      icon="list-dots-dual-column"
      :size="iconSize"
      :color="iconColor"
    />
  </div>
</template>

<script>
import EgIcon from "@/components/global/eg/eg_icon.vue";

export default {
  name: "WizardDragZone",
  components: { EgIcon },
  props: {
    align: { type: String, default: "flex-start" },
    paddingTop: { type: Number, default: 2 },
    iconSize: { type: String, default: "small" },
    iconColor: {
      type: String,
      default: "var(--color-text-neutral-neutral)",
    },
  },
  computed: {
    computedStyle() {
      return {
        display: "flex",
        alignItems: this.align,
        paddingTop: `${this.paddingTop}px`,
      };
    },
  },
};
</script>

<style scoped>
.wizard-drag-zone :deep(.drag-handle) {
  cursor: grab;
}
</style>
